<template>
  <div>
    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        :value="partnerName" 
        :options="partnerOptions" 
        :reduce="val => val.value"
        :close-on-select="true"
        :disabled="loading"
        @input="onOptionSelected"
      />
    </div>
  </div>
</template>
  
<script>
// import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  
export default {
  components: {
    vSelect,
    BButton,

  },
  data() {
    return {
      loading: false,
      toggleModal: false,
      partnerName: null,

      partnerOptions: [
        { label: 'Ahotopa Comfort', value: 'Ahotopa Comfort' },
        { label: 'Ahotopa with MTN', value: 'Ahotopa with MTN' },
        { label: 'Premier Health', value: 'Premier Health' },
        { label: 'Teledokta', value: 'Teledokta' },
      ],
    }
  },
  methods: {
    // async fetchDoctors(text, loadingMutator) {
    //   try {
    //     this.loading = true; 
    //     loadingMutator(true);

    //     const query = {
    //       page: 1,
    //       limit: 50,
    //       search: text || this.value,
    //       status: 'active'
    //     }
        
    //     const request = await this.useJwt().mainService.users.list(query);
    //     const { data } = request.data;
    //     this.doctors = data.map(opt => ({ id: opt._id, name: `${opt.full_name} | ${opt.email}` }))
    //   } catch (error) {
    //     const error_message = get(error, "response.data.message") || error.message
    //     console.log("error_message", error_message)
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Error!',
    //         icon: 'AlertTriangleIcon',
    //         variant: 'danger',
    //         text: error_message
    //       },
    //     });
    //   } finally {
    //     this.loading = false;
    //     loadingMutator(false);
    //   }
    // },
    onOptionSelected(val){
      this.partnerName = val
      this.$emit('change', val)
    },
  }
}
</script>
